module.exports = __webpack_public_path__ + "static/pokoj-nr4-photo01-nikon_thumb-0a4376a16a9ef2770275e22729df7bbf.jpg";